export const NOTICE_LIST_PAGE_UUID = '297b7a67-8171-4045-bf5c-1418433e9e62'
